import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
// MongoDB's own verdict on a drawn shape: the last safeguard of the save methods, behind the shape rules (#7). The rules
// (shapeRules.js) mirror what MongoDB refuses; this asks MongoDB itself, so a case where they still differ (a corner a
// hair from a side, another MongoDB version) is refused before anything is stored. Neither the places nor the
// communities have a 2dsphere index on their shape, so MongoDB would store such a shape and only fail when matching it.
//
// It asks with a query on a collection that never exists: MongoDB reads the shape, refuses it if it cannot use it, and
// finds nothing in no time. Server only; in a method's simulation on the client it says yes.
import { Meteor } from 'meteor/meteor';
var PROBE = 'shapeProbe'; // what MongoDB answers about a shape it cannot read (BadValue, "Can't extract geo keys"); anything else (no connection,
// a timeout) is not the shape's fault and is thrown on

var SHAPE_ERRORS = [2, 16755];
/**
 * @param {Mongo.Collection} collection any server collection (for its database)
 * @param {Object} geometry a GeoJSON Polygon or MultiPolygon
 * @returns {?string} 'mongo' when MongoDB refuses the shape, else null; throws when MongoDB cannot be asked
 */

export var mongoRejectReason = function mongoRejectReason(collection, geometry) {
  if (!Meteor.isServer) return null;

  try {
    Promise.await(collection.rawDatabase().collection(PROBE).findOne({
      g: {
        $geoIntersects: {
          $geometry: geometry
        }
      }
    }));
    return null;
  } catch (e) {
    if (SHAPE_ERRORS.includes(e.code)) return 'mongo';
    throw e;
  }
}; // that a query on a collection that does not exist reads the shape is not documented: at the start, a crossing shape
// must be refused, or the safeguard is off on this MongoDB and the log says so (the shape rules still hold)

export var checkShapeProbe = function checkShapeProbe(collection) {
  var bowTie = {
    type: 'Polygon',
    coordinates: [[[6.5, 53.2], [6.51, 53.21], [6.51, 53.2], [6.5, 53.21], [6.5, 53.2]]]
  };
  var reason;

  try {
    reason = mongoRejectReason(collection, bowTie);
  } catch (e) {
    reason = 'error: ' + (e.message || e);
  }

  if (reason !== 'mongo') console.warn('shape probe: MongoDB did not refuse a crossing shape (' + reason + '); the save methods check the shape rules only');
  return reason === 'mongo';
};